import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getClientAwscCall = (state, clientId) =>
  allModelsSelector(state, 'AwscCall', (call) => call.clientId === clientId);
